import React from 'react'
import styled from 'styled-components'
import { FONT } from 'theme/font'

const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  // margin-top: 8px;
`

const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #F5F8FF;
  border: none;
  border-radius: 8px;
  color: #444CE7;
  font-size: ${FONT.F_SM};
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #EEF4FF;
  }
`

const BulkUploadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  font-size: ${FONT.F_SM};
  background: #444CE7;
  height: 40px;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #3D45D0;
  }
`

const UploadButtons = ({ 
  downloadText = "Download Template",
  uploadText = "Bulk Upload",
  onDownloadClick,
  onUploadClick,
  downloadIcon: DownloadIcon
}) => {
  return (
    <ButtonsContainer>
      {/* <DownloadButton onClick={onDownloadClick}>
        {DownloadIcon && <DownloadIcon />}
        {downloadText}
      </DownloadButton> */}
      <BulkUploadButton onClick={onUploadClick}>
        {uploadText}
      </BulkUploadButton>
    </ButtonsContainer>
  )
}

export default UploadButtons
